module.exports = __webpack_public_path__ + "img/kefu.3b2ee977.png";